import React, { createContext, FunctionComponent, useState } from 'react';

interface AppContextType {
  userId?: number;
  setUserId: (userId?: number) => void;
  isSuperadmin: boolean;
  setIsSuperadmin: (isSuperadmin: boolean) => void;
  errorMessage?: string;
  setErrorMessage: (message?: string) => void;
  clearContext: () => void;
}

export const AppContext = createContext<AppContextType>({
  isSuperadmin: false,
  setUserId: (userId?: number) => {
    return;
  },
  setIsSuperadmin: (isSuperadmin: boolean) => {
    return;
  },
  setErrorMessage: (message?: string) => {
    return;
  },

  clearContext: () => {
    return;
  },
});

export const AppContextProvider: FunctionComponent = ({ children }) => {
  const [userId, setUserId] = useState<number | undefined>(undefined);
  const [isSuperadmin, setIsSuperadmin] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const clearContext = () => {
    setUserId(undefined);
    setIsSuperadmin(false);
    setErrorMessage(undefined);
  };

  return (
    <AppContext.Provider
      value={{
        userId,
        setUserId,
        isSuperadmin,
        setIsSuperadmin,
        errorMessage,
        setErrorMessage,
        clearContext,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
